<template>
  <div class="content">
    <LinkPath current-path="exclusão biométrica"/>
    <section>
      <div class="row">
        <div class="col-md-12">
          <div class="box box-info">
            <div class="form-group">
              <form id="formBio" style="padding: 10px !important;">

                <div id="divAlert" class="alert alert-success" role="alert" style="margin: 16px; display:none;"></div>

                <div class="form-row input-row">
                  <div class="col-md-3 mb-3">
                    <label for="dataIni">Data Início</label>
                    <div class="input-group">
                              <span class="input-group-addon" style="padding: 12px 34px 0 19px">
                                  <i class="fa fa-fw fa-calendar"></i>
                              </span>
                      <datepicker class="datetime-picker" format="dd/MM/yyyy" :language="ptBR" v-model="dtIni"
                                  id="dataIni" width="220px" required></datepicker>
                    </div>
                  </div>

                  <div class="col-md-3 mb-3">
                    <label for="dateFim">Data Fim</label>
                    <div class="input-group">
                              <span class="input-group-addon" style="padding: 12px 34px 0 19px">
                                  <i class="fa fa-fw fa-calendar"></i>
                              </span>
                      <datepicker class="datetime-picker" format="dd/MM/yyyy" :language="ptBR" v-model="dtFim"
                                  id="dateFim" width="220px" required></datepicker>
                    </div>
                  </div>

                  <div class="col-md-3 mb-3 input-box-wrapper">
                    <label for="cpf">CPF</label>
                    <input type="text" class="input-box" id="cpf" v-model="cpf">
                  </div>

                  <div class="col-md-3 mb-3">
                    <button id="btnPesq" type="button" class="btn btn-primary" style="margin-top: 7%;"
                            v-on:click="searchAnalisys()">Pesquisar
                    </button>
                    <button type="button" class="btn btn-secondary" style="margin-left: 3%; margin-top: 7%;"
                            v-on:click="clearFilter()">Limpar Filtros
                    </button>
                  </div>
                </div>

                <div class="form-row input-row">
                  <div class="col-md-3 mb-3 input-box-wrapper">
                    <label for="status">
                      Status
                    </label>
                    <select id="status" class="input-box" v-model="status">
                      <option value=""></option>
                      <option value="IN_ANALISIS">Em análise</option>
                      <option value="PROCESSED">Concluído</option>
                      <option value="SECURITY">Segurança</option>
                    </select>
                  </div>

                  <div class="col-md-3 mb-3 input-box-wrapper">
                    <label for="cpf">Usuário</label>
                    <input type="text" class="input-box" id="user" v-model="user">
                  </div>
                </div>

                <div class="form-row input-row">
                  <div class="col-md-3 mb-3 input-box-wrapper">
                    <label for="id_analisys">ID</label>
                    <input type="text" class="input-box" id="id_analisys" v-model="id">
                  </div>

                  <div class="col-md-3 mb-3 input-box-wrapper">
                    <label for="idn">IDN</label>
                    <input type="text" class="input-box" id="idn" v-model="idn">
                  </div>
                </div>

                <div style="clear:both;"></div>

                <a id="editDelete" class="btn btn-primary" style="display: none;"
                   v-on:click="toggleClassByName('show', '#divViewDelete')"
                   href="#divViewDelete" role="button"
                   data-toggle="divViewDelete"
                   data-target="#divViewDelete" aria-expanded="false"
                   aria-controls="divViewDelete"/>

                <div class="box box-info .collapse" id="divViewDelete"
                     style="margin-top: 10px; margin-bottom: 5px; margin-left: 1.5%; width: 97%; display: none;">

                  <div class="form-group" style="margin-top: 6px; margin-bottom: 22px;">
                    <input v-if="deleteEdit.process" v-on:click="print()" class="print btn btn-primary"
                           style="float: right;" type="button" id="btPrint" value="Imprimir Análise"/>
                  </div>

                  <div class="form-group">
                    <label class="control-label">ID Análise</label><br/>
                    <div class="well well-sm">
                      {{ deleteEdit.id }}
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label">CPF</label><br/>
                    <div class="well well-sm">
                      {{ deleteEdit.cpf }}
                    </div>
                  </div>

                  <h4>Primeira Análise</h4>

                  <div class="form-group">
                    <label class="control-label">Motivo</label><br/>
                    <div class="well well-sm">
                      {{ deleteEdit.translateStatusCreation }}
                    </div>
                  </div>
                  <br/>
                  <div class="form-group">
                    <label class="control-label">Descrição</label><br/>
                    <div name="description" class="divTextArea">
                      {{ deleteEdit.descriptionCreation }}
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="col" v-if="deleteEdit.userCreation">
                      <b>Usuário: </b>{{ deleteEdit.userCreation.username }} &nbsp;&nbsp;
                      <b>Nome: </b>{{ deleteEdit.userCreation.name }} &nbsp;&nbsp; <b>Data
                      Criação: </b>{{ deleteEdit.formatCreationDate }}
                    </div>
                  </div>

                  <div class="spacer30"></div>

                  <h4
                    v-if="deleteEdit.userModification || (deleteEdit.process && deleteEdit.userModification) || (!deleteEdit.process && !deleteEdit.securityOnly)"
                    style="margin-top: 20px;">Segunda Análise</h4>

                  <div class="alert alert-warning" role="alert"
                       v-if="deleteEdit.userCreation && (sessionUser === deleteEdit.userCreation.username) && !deleteEdit.userModification && !deleteEdit.securityOnly && !deleteEdit.process">
                    <span>O mesmo usuário não pode efetuar mais de uma análise para o mesmo registro.</span>
                  </div>

                  <div
                    v-if="deleteEdit.userModification || (!deleteEdit.process && !deleteEdit.securityOnly && (deleteEdit.userCreation && (sessionUser !== deleteEdit.userCreation.username)))">
                    <div class="col-md-12 mb-4" style="margin-bottom: 10px;">
                      <div class="row">
                        <label for="status">
                          Motivo
                        </label>
                        <select style="width: 50%; height: 20px" v-if="!deleteEdit.userModification" id="status"
                                v-model="deleteEdit.statusModification">
                          <option v-for="mot in listMotivos" :key="mot.value" :value="mot.value">{{ mot.name }}</option>
                        </select>
                        <div v-else class="well well-sm">
                          {{ deleteEdit.translateStatusModification }}
                        </div>
                      </div>
                    </div>
                    <br>
                    <div class="form-group">
                      <label class="control-label">
                        Descrição
                      </label><br/>
                      <textarea id="descModification" v-if="!deleteEdit.userModification"
                                v-model="deleteEdit.descriptionModification" rows="10" cols="159" required></textarea>
                      <div v-else name="description" class="divTextArea">
                        {{ deleteEdit.descriptionModification }}
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="col" v-if="deleteEdit.userModification">
                        <b>Usuário </b>{{ deleteEdit.userModification.username }} &nbsp;&nbsp;
                        <b>Nome: </b>{{ deleteEdit.userModification.name }} &nbsp;&nbsp; <b>Data
                        Criação: </b>{{ deleteEdit.formatModificationDate }}
                      </div>
                    </div>

                  </div>

                  <div
                    v-if="deleteEdit.userSecurity || (this.security && ((deleteEdit.userModification && (deleteEdit.statusCreation !== deleteEdit.statusModification )) || ( deleteEdit.securityOnly || deleteEdit.userModification)))">

                    <h4 style="margin-top: 20px;">Análise de Segurança</h4>

                    <div class="form-group div-motivo-security">
                      <div class="col-md-12 mb-4" style="margin-bottom: 10px;">
                        <div class="row">
                          <label for="status">
                            Motivo
                          </label>
                          <select style="width: 50%;" v-if="!deleteEdit.userSecurity" class="form-control"
                                  v-model="deleteEdit.statusSecurity">
                            <option v-for="mot in listMotivos" :key="mot.value" :value="mot.value">{{ mot.name }}
                            </option>
                          </select>
                          <div v-else class="well well-sm">
                            {{ deleteEdit.translateStatusSecurity }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="control-label">
                        Descrição
                      </label><br/>
                      <textarea id="descSecurity" v-if="!deleteEdit.userSecurity"
                                v-model="deleteEdit.descriptionSecurity" rows="10" cols="159" required></textarea>
                      <div v-else name="description" class="divTextArea">
                        {{ deleteEdit.descriptionSecurity }}
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col" v-if="deleteEdit.userSecurity">
                        <b>Usuário </b>{{ deleteEdit.userSecurity.username }} &nbsp;&nbsp;
                        <b>Nome: </b>{{ deleteEdit.userSecurity.name }} &nbsp;&nbsp; <b>Data
                        Criação: </b>{{ deleteEdit.formatSecurityDate }}
                      </div>
                    </div>
                  </div>

                  <div style="clear:both;"></div>

                  <div class="form-row" style="margin-bottom: 5px;">
                    <div class="form-group">
                      <div style="margin-right: 5px; float: right; margin-bottom: 5px;">
                        <button
                          v-if="check('SAVE') && !deleteEdit.process && ((security && deleteEdit.securityOnly) || (deleteEdit.userCreation && (sessionUser !== deleteEdit.userCreation.username)))"
                          type="submit" v-on:click="save($event)" class="btn btn-primary">Salvar
                        </button>
                        <button type="button" v-on:click="cancelEdit()" class="print btn btn-secondary">Cancelar
                        </button>
                      </div>
                    </div>
                  </div>
                  <div style="clear:both;"></div>
                </div>

              </form>

              <div id="divblank" class="divBlank">
                <div id="divTab" style="display:none;">
                  <div class="row center-block">
                    <div class="col-md-12">
                      <div class="box">

                        <!-- /.box-header -->
                        <div class="box-body">
                          <div class="dataTables_wrapper form-inline dt-bootstrap" id="tabDelete_wrapper">
                            <div class="row">
                              <div class="col-sm-6">
                                <div id="tabDelete_length" class="dataTables_length">

                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-sm-12 table-responsive">
                                <table aria-describedby="tabDelete" role="grid" id="tabDelete"
                                       class="table table-bordered table-striped dataTable">
                                  <thead>
                                  <tr role="row">
                                    <th colspan="1" rowspan="1" aria-controls="tabDelete" tabindex="0">Ação</th>
                                    <th colspan="1" rowspan="1" aria-controls="tabDelete" tabindex="0">ID</th>
                                    <th colspan="1" rowspan="1" aria-controls="tabDelete" tabindex="0">CPF</th>
                                    <th colspan="1" rowspan="1" aria-controls="tabDelete" tabindex="0">IDN</th>
                                    <th colspan="1" rowspan="1" aria-controls="tabDelete" tabindex="0">Data 1° Análise
                                    </th>
                                    <th colspan="1" rowspan="1" aria-controls="tabDelete" tabindex="0">Reportado por
                                    </th>
                                    <th colspan="1" rowspan="1" aria-controls="tabDelete" tabindex="0">Data 2° Análise
                                    </th>
                                    <th colspan="1" rowspan="1" aria-controls="tabDelete" tabindex="0">Analisado por
                                    </th>
                                    <th colspan="1" rowspan="1" aria-controls="tabDelete" tabindex="0">Data Análise
                                      Segurança
                                    </th>
                                    <th colspan="1" rowspan="1" aria-controls="tabDelete" tabindex="0">Analista
                                      Segurança
                                    </th>
                                    <th colspan="1" rowspan="1" aria-controls="tabDelete" tabindex="0">Status</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="(del, index) in listaAnalisys" :key="del.id" class="even" role="row">
                                    <td><a href="#" v-on:click="editAnalisys(index)" title="Visualizar Análise"><i
                                      class="fa fa-eye" style="margin-left: 35%;"/></a></td>
                                    <td>{{ del.id }}</td>
                                    <td>{{ del.cpf }}</td>
                                    <td style="max-width: 130px; word-wrap: break-word;">{{ del.idn }}</td>
                                    <td data-sort="<%= audit.formatDate.strftime('%Y%m%d%H%M%s') %>">
                                      {{ del.formatCreationDate }}
                                    </td>
                                    <td>{{ del.userCreation.name }}</td>
                                    <td data-sort="<%= audit.formatDate.strftime('%Y%m%d%H%M%s') %>">
                                      {{ del.formatModificationDate }}
                                    </td>
                                    <td>{{ del.nameUserModification }}</td>
                                    <td data-sort="<%= audit.formatDate.strftime('%Y%m%d%H%M%s') %>">
                                      {{ del.formatSecurityDate }}
                                    </td>
                                    <td>{{ del.nameUserSecurity }}</td>
                                    <td>
                                      <span v-if="del.process">Concluído</span>
                                      <span v-else-if="!del.process && !del.securityOnly && !del.statusModification">Em análise</span>
                                      <span v-else>Segurança</span>
                                    </td>
                                  </tr>
                                  </tbody>
                                  <tfoot>
                                  <tr>
                                    <th colspan="1" rowspan="1">Ação</th>
                                    <th colspan="1" rowspan="1">ID</th>
                                    <th colspan="1" rowspan="1">CPF</th>
                                    <th colspan="1" rowspan="1">IDN</th>
                                    <th colspan="1" rowspan="1">Data 1° Análise</th>
                                    <th colspan="1" rowspan="1">Reportado por</th>
                                    <th colspan="1" rowspan="1">Data 2° Análise</th>
                                    <th colspan="1" rowspan="1">Analisado por</th>
                                    <th colspan="1" rowspan="1">Data Análise Segurança</th>
                                    <th colspan="1" rowspan="1">Analista Segurança</th>
                                    <th colspan="1" rowspan="1">Status</th>
                                  </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                          </div>
                          <!-- /.box-body -->
                          <div style="clear:both;"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>


    </section>
  </div>
</template>

<script>
import $ from 'jquery'
import interceptor from '../../interceptor'
import 'datatables.net'
import 'datatables.net-bs'
import Datepicker from 'vuejs-datepicker'
import {ptBR} from 'vuejs-datepicker/dist/locale'
import roles from '../../roles'
import Delete from '../../model/Delete'
import LinkPath from '../components/LinkPath'

export default {
  name: 'DeleteBio',
  data: function () {
    return {
      listaAnalisys: [],
      listMotivos: [],
      dtIni: '',
      dtFim: '',
      ptBR: ptBR,
      cpf: '',
      idn: '',
      status: '',
      user: '',
      deleteEdit: new Delete(),
      key: 'EXCBIO',
      enabled: true,
      id: '',
      sessionUser: '',
      security: false
    }
  },
  components: {
    LinkPath,
    Datepicker
  },
  methods: {
    toggleClassByName(className, id) {
      $(id).toggle(className)
    },
    check: function (action) {
      return roles.checkrole(window.localStorage.getItem('role'), this.key, action)
    },
    searchAnalisys: function () {
      $('#btnPesq').attr('disabled', true)
      this.clear()
      if ((this.dtIni !== '' && this.dtFim === '') || (this.dtFim !== '' && this.dtIni === '')) {
        $('#divAlert').attr('class', 'alert alert-warning')
          .append('<p style="font-weight: bold;">Para pesquisar utilizando um período ambas as datas devem ser preenchidas. </p>')
          .show()
      } else if (this.dtIni > this.dtFim) {
        $('#divAlert').attr('class', 'alert alert-warning')
          .append('<p style="font-weight: bold;">Data Início não pode ser maior que Data Fim. </p>')
          .show()
      } else {
        var URL = 'api/v1/delete'
        const idnEncoded = encodeURIComponent(this.idn)
        if (this.dtIni !== '' && this.dtFim !== '') {
          var dtIni = this.formatDate(this.dtIni)
          var dtFim = this.formatDate(this.dtFim)
          URL += '?dtIni=' + dtIni + '&dtFim=' + dtFim + '&status=' + this.status + '&cpf=' + this.cpf + '&usuario=' + this.user + '&idn=' + idnEncoded + '&id=' + this.id
        } else {
          URL += '?status=' + this.status + '&cpf=' + this.cpf + '&idn=' + idnEncoded + '&usuario=' + this.user + '&id=' + this.id
        }
        interceptor.request('get', URL, {})
          .then(response => {
            this.listaAnalisys = response.data
            this.refreshData()
            this.$nextTick(() => {
              $('#tabDelete').DataTable({
                'oLanguage': {
                  'sUrl': '/static/json/languageDataTable.json'
                }
              })
            })
            $('#divblank').attr('class', '')
            $('#divTab').show()
          })
          .catch(function (error) {
            var msg = error.response.status
            if (msg === 404) {
              $('#divAlert').attr('class', 'alert alert-warning')
                .append('<p style="font-weight: bold;">Nenhuma análise foi encontrada.</p>')
                .show()
            } else {
              $('#divAlert').attr('class', 'alert alert-danger')
                .append('<p style="font-weight: bold;">Erro ao tentar efetuar a pesquisa. Serviço indisponível.</p>')
                .show()
            }
            this.$nextTick(() => {
              $('#tabDelete').DataTable({
                'oLanguage': {
                  'sUrl': '/static/json/languageDataTable.json'
                }
              }).destroy()
            })
          })
      }
      setTimeout(() => $('#btnPesq').attr('disabled', false), 2000)
    },
    editAnalisys: function (index) {
      $('#divAlert').empty().hide()
      this.deleteEdit = this.listaAnalisys[index]
      interceptor.request('post', 'api/v1/delete/blockregistry/' + this.deleteEdit.id + '/' + this.sessionUser, {})
        .then(response => {
          console.log('response')
          console.log(response)
          console.log('response')
          console.log('this.sessionUser')
          console.log(this.sessionUser)
          console.log('this.sessionUser')
          var registry = response.data
          console.log('registry.userBlocked.username')
          console.log(registry.userBlocked.username)
          console.log('registry.userBlocked.username')
          this.deleteEdit = registry
          if (registry.process || registry.userCreation.username === this.sessionUser || registry.userBlocked.username === this.sessionUser) {
            var classe = $('#divViewDelete').attr('class')
            if (classe !== 'collapse in') {
              document.getElementById('editDelete').click()
            }
          } else {
            $('#divAlert').attr('class', 'alert alert-warning')
              .append('<p style="font-weight: bold;">Este registro esta em análise pelo usuário ' + registry.userBlocked.name + '.</p>')
              .show()
          }
        })
    },
    cancelEdit: function () {
      this.deleteEdit = new Delete()
      document.getElementById('editDelete').click()
    },
    save: function (event) {
      $('#divAlert').empty().hide()
      event.preventDefault()
      if (!this.deleteEdit.securityOnly && !this.deleteEdit.userModification && (this.deleteEdit.statusModification === '' || this.deleteEdit.statusModification === undefined) &&
        (this.deleteEdit.descriptionModification === '' || this.deleteEdit.descriptionModification === undefined)) {
        $('#divAlert').attr('class', 'alert alert-warning')
          .append('<p style="font-weight: bold;">Os campos Motivo e Descrição devem ser preenchidos.</p>')
          .show()
        return
      }
      if (this.security && !this.deleteEdit.userSecurity && (this.deleteEdit.statusSecurity === '' || this.deleteEdit.statusSecurity === undefined) &&
        (this.deleteEdit.descriptionSecurity === '' || this.deleteEdit.descriptionSecurity === undefined)) {
        $('#divAlert').attr('class', 'alert alert-warning')
          .append('<p style="font-weight: bold;">Os campos Motivo e Descrição devem ser preenchidos.</p>')
          .show()
        return
      }
      this.deleteEdit.userCreation = this.deleteEdit.userCreation.username
      if (this.deleteEdit.userModification) {
        this.deleteEdit.userModification = this.deleteEdit.userModification.username
      }
      if (this.deleteEdit.userSecurity) {
        this.deleteEdit.userSecurity = this.deleteEdit.userSecurity.username
      }
      this.deleteEdit.userSession = this.sessionUser
      interceptor.request('post', 'api/v1/delete/savedeleteanalisys', this.deleteEdit)
        .then(response => {
          $('#divAlert').attr('class', 'alert alert-success')
            .append('<p style="font-weight: bold;">Análise foi atualizada com sucesso.</p>')
            .show()
          this.cancelEdit()
          var URL = 'api/v1/delete'
          if (this.dtIni !== '' && this.dtFim !== '') {
            var dtIni = this.formatDate(this.dtIni)
            var dtFim = this.formatDate(this.dtFim)
            URL += '?dtIni=' + dtIni + '&dtFim=' + dtFim + '&status=' + this.status + '&cpf=' + this.cpf + '&usuario=' + this.user + '&id=' + this.id
          } else if (this.idn) {
            URL += '?status=' + this.status + '&cpf=' + this.idn + '&usuario=' + this.user + '&id=' + this.id
          } else if (this.cpf) {
            URL += '?status=' + this.status + '&cpf=' + this.cpf + '&usuario=' + this.user + '&id=' + this.id
          }
          interceptor.request('get', URL, {})
            .then(response => {
              this.listaAnalisys = response.data
              this.refreshData()
              this.$nextTick(() => {
                $('#tabDelete').DataTable({
                  'oLanguage': {
                    'sUrl': '/static/json/languageDataTable.json'
                  }
                })
              })
              $('#divblank').attr('class', '')
              $('#divTab').show()
            })
            .catch(function (error) {
              var msg = error.response.status
              if (msg === 404) {
                $('#divAlert').attr('class', 'alert alert-danger')
                  .append('<p style="font-weight: bold;">Nenhuma análise foi encontrada.</p>')
                  .show()
              } else {
                $('#divAlert').attr('class', 'alert alert-danger')
                  .append('<p style="font-weight: bold;">Erro ao tentar efetuar a pesquisa. Serviço indisponível.</p>')
                  .show()
              }
              this.$nextTick(() => {
                $('#tabDelete').DataTable({
                  'oLanguage': {
                    'sUrl': '/static/json/languageDataTable.json'
                  }
                }).destroy()
              })
            })
        })
        .catch(function (error) {
          console.log(error.response.status)
          $('#divAlert').attr('class', 'alert alert-danger')
            .append('<p style="font-weight: bold;">Ocorreu um erro ao tentar atualizar a análise.</p>')
            .show()
        })
    },
    deleteBio: function () {
      interceptor.request('delete', 'api/v1/delete/' + this.cpf + '/' + this.motivo + '/' + this.obs, {})
        .then(response => {
          if (response.status === 200) {
            $('#divAlert').attr('class', 'alert alert-success')
              .append('<p style="font-weight: bold;">Subject: ' + this.cpf + ' excluído com sucesso.</p>')
              .show()
          }
        })
    },
    print: function () {
      const conteudo = $('#divViewDelete').html()
      // var telaImpressao = window.open('about:blank')
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('about:blank')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
        <head>
          ${stylesHtml}
        </head>
        <body>
          ${conteudo}
        </body>
        </html>`)
      WinPrint.document.close()
      WinPrint.window.focus()
      WinPrint.window.print()
    },
    formatDate: function (date) {
      var day = date.getDate()
      var month = date.getMonth() + 1
      var year = date.getFullYear()
      return day + '-' + month + '-' + year
    },
    clear: function () {
      $('#divAlert').empty().hide()
      $('#divTab').hide()
    },
    drawDT() {
      $('#tabDelete').DataTable().draw()
    },
    async refreshData() {
      this.isLoading = true
      $('#tabDelete').DataTable().destroy()
      try {
        await this.$nextTick(this.drawDT)
      } catch (err) {
        console.error(err)
      } finally {
        this.isLoading = false
      }
    },
    clearList: function () {
      this.listaAnalisys = []
    },
    clearFilter: function () {
      this.clear()
      this.clearList()
      this.status = ''
      this.cpf = ''
      this.idn = ''
      this.user = ''
      this.dtIni = ''
      this.dtFim = ''
      location.reload()
    }
  },
  mounted() {
    this.sessionUser = window.localStorage.getItem('usercod')
    interceptor.request('get', 'api/v1/delete/listmotivos', {})
      .then(response => {
        this.listMotivos = response.data
      })
    var profile = window.localStorage.getItem('role')
    if (profile === 'ADMIN') {
      this.security = true
    }
  }
}

$(function () {
  $(document).ready(function () {
    $('#descModification').on('keyup', function (e) {
      $(this).val($(this).val().replace(/\//g, ''))
      $(this).val($(this).val().replace(/\\/g, ''))
    })
    $('#descSecurity').on('keyup', function (e) {
      $(this).val($(this).val().replace(/\//g, ''))
      $(this).val($(this).val().replace(/\\/g, ''))
    })
  })
})

</script>

<style>

@page {
  size: portrait;
}

@media print {
  .print {
    display: none;
  }

  textarea[name="description"] {
    width: 90% !important;
  }
}

.divBlank {
  background-color: white;
  height: 500px;
}

.divTextArea {
  width: 90%;
  border: solid 1px lightgrey;
  border-radius: 5px;
  height: 150px;
}

.input-box {
  min-width: 200px;
  height: 25px;
  border: lightslategrey solid 1px !important;
  border-radius: 2% !important;
}

.input-box-wrapper {
  display: flex;
  flex-direction: column;
}

.datetime-picker {
  border: lightslategrey solid 1px !important;
  border-radius: 2% !important;
}

</style>



// WEBPACK FOOTER //
// Delete.vue?6ae62523